module.exports = __webpack_public_path__ + "static/bg_instituut-9bd5b61cbb5301cd37b73aab6601423c.jpg";